import * as tslib_1 from "tslib";
import { NormalBasicChunk } from "./NormalBasicChunk";
/**
 * NormalSimpleWaterChunk provides a basic normal map method to create water ripples by translating two wave normal maps.
 */
var NormalSimpleWaterChunk = (function (_super) {
    tslib_1.__extends(NormalSimpleWaterChunk, _super);
    /**
     * Creates a new NormalHeightMapChunk.
     */
    function NormalSimpleWaterChunk(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    NormalSimpleWaterChunk.prototype._initConstants = function () {
        var index = this._fragmentConstantsIndex;
        var data = this._shader.fragmentConstantData;
        data[index] = .5;
        data[index + 1] = 0;
        data[index + 2] = 0;
        data[index + 3] = 1;
    };
    /**
     * @inheritDoc
     */
    NormalSimpleWaterChunk.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        if (this._method.secondaryNormalMap) {
            this._secondaryNormalMap = this._shader.getAbstraction(this._method.secondaryNormalMap);
            this._shader.uvDependencies++;
        }
    };
    /**
     * @inheritDoc
     */
    NormalSimpleWaterChunk.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._secondaryNormalMap = null;
    };
    /**
     * @inheritDoc
     */
    NormalSimpleWaterChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        if (this._invalid) {
            var data = this._shader.fragmentConstantData;
            var index = this._fragmentConstantsIndex;
            data[index + 4] = this._method.water1OffsetX;
            data[index + 5] = this._method.water1OffsetY;
            data[index + 6] = this._method.water2OffsetX;
            data[index + 7] = this._method.water2OffsetY;
        }
        if (this._secondaryNormalMap)
            this._secondaryNormalMap.activate();
    };
    /**
     * @inheritDoc
     */
    NormalSimpleWaterChunk.prototype._setRenderState = function (renderable, projection) {
        _super.prototype._setRenderState.call(this, renderable, projection);
        if (this._secondaryNormalMap)
            this._secondaryNormalMap._setRenderState(renderable);
    };
    /**
     * @inheritDoc
     */
    NormalSimpleWaterChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var dataReg = registerCache.getFreeFragmentConstant();
        var dataReg2 = registerCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = dataReg.index * 4;
        code += "add " + temp + ", " + sharedRegisters.uvVarying + ", " + dataReg2 + ".xyxy\n";
        if (this._texture)
            code += this._texture._getFragmentCode(targetReg, registerCache, sharedRegisters, temp);
        code += "add " + temp + ", " + sharedRegisters.uvVarying + ", " + dataReg2 + ".zwzw\n";
        if (this._secondaryNormalMap)
            code += this._secondaryNormalMap._getFragmentCode(temp, registerCache, sharedRegisters, temp);
        code += "add " + targetReg + ", " + targetReg + ", " + temp + "		\n" +
            "mul " + targetReg + ", " + targetReg + ", " + dataReg + ".x	\n" +
            "sub " + targetReg + ".xyz, " + targetReg + ".xyz, " + sharedRegisters.commons + ".xxx	\n" +
            "nrm " + targetReg + ".xyz, " + targetReg + ".xyz							\n";
        return code;
    };
    return NormalSimpleWaterChunk;
}(NormalBasicChunk));
export { NormalSimpleWaterChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/NormalSimpleWaterChunk.js